const getClassName = (title, splitPattern = " ") => {
    if (typeof title !== "string") {
        return "";
    }
    return title.replace(splitPattern, "-").toLowerCase();
}

export default getClassName;